export function logout() {
  localStorage.removeItem("corp");
}

export function isLoggedIn() {
  return localStorage.getItem("corp") !== null;
}
